function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.7499V22.25C16.1355 22.249 17.413 22.2374 18.4222 22.1015C19.3293 21.9793 20.0445 21.7545 20.6244 21.3316L20.2661 20.9732C19.7868 21.3016 19.1794 21.495 18.3556 21.6056L14.5 21.7499ZM14.5 21.7499C16.1416 21.7487 17.3838 21.7362 18.3555 21.6056L14.5 21.7499ZM3.37571 2.66866L3.73401 3.02695C4.21413 2.69834 4.82343 2.50497 5.65179 2.39446L3.37571 2.66866ZM3.37571 2.66866C3.9562 2.24591 4.67397 2.02098 5.58551 1.89861L3.37571 2.66866ZM9.53 1.75014C7.88374 1.75111 6.59912 1.76259 5.58552 1.89861L9.53 1.75014ZM9.53 1.75014V2.25018C7.87841 2.25137 6.62939 2.26387 5.65189 2.39445L9.53 1.75014ZM2.39444 18.3556C2.50501 19.1794 2.69845 19.7868 3.02682 20.2661L2.66847 20.6245C2.24559 20.0446 2.02082 19.3294 1.89853 18.4223C1.76262 17.4131 1.75107 16.1356 1.75009 14.5001H2.25013C2.25133 16.1417 2.26388 17.3838 2.39444 18.3556ZM13.5 22.2501H10.5V21.7501H13.5V22.2501ZM5.64354 21.6056C6.61703 21.7362 7.85842 21.7487 9.5 21.7499V22.25C7.86429 22.249 6.5861 22.2374 5.5778 22.1015C4.67003 21.9792 3.955 21.7549 3.3759 21.3313L3.73438 20.9728C4.21339 21.3017 4.82079 21.4951 5.64344 21.6056L5.64354 21.6056ZM21.3312 20.6242L20.9727 20.2657C21.3017 19.7867 21.495 19.1793 21.6056 18.3566L21.6056 18.3566C21.7361 17.384 21.7487 16.1418 21.7499 14.5001H22.2499C22.2489 16.1358 22.2374 17.414 22.1015 18.4223C21.9791 19.33 21.7548 20.0451 21.3312 20.6242ZM22.0514 10.5241C22.2285 11.1682 22.2477 11.9311 22.2498 13.0631H21.7496C21.7468 11.9636 21.7272 11.2807 21.5886 10.7303L22.0514 10.5241ZM21.645 9.61038L21.1817 9.81684C20.8653 9.34595 20.3704 8.87425 19.5555 8.13703L19.8903 7.76451C20.7311 8.52357 21.2851 9.04738 21.645 9.61038ZM18.8126 7.4677L15.5972 4.57397L15.9325 4.20159L19.1472 7.09541L18.8126 7.4677ZM12.4368 2.36113C11.9749 2.26886 11.4074 2.2532 10.53 2.25058V1.75035C11.4433 1.75238 12.0765 1.76816 12.6183 1.88878L12.4368 2.36113ZM1.75 13.5001V10.5001H2.25V13.5001H1.75ZM2.6688 3.37596L3.02727 3.73443C2.69831 4.21344 2.50496 4.82084 2.39445 5.64349L2.39444 5.6436C2.26388 6.61708 2.25133 7.85847 2.25013 9.50006H1.75009C1.75107 7.86435 1.76262 6.58617 1.89852 5.57786C2.0209 4.67009 2.2452 3.95505 2.6688 3.37596ZM13.5523 2.24712C14.034 2.51887 14.5127 2.92817 15.1882 3.53314L14.8534 3.90524C14.2042 3.32442 13.7749 2.95878 13.3712 2.71923L13.5523 2.24712Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.4995H14M6 17.9995H11.5",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 2.49951V4.99951C13.0002 7.35651 13.0002 8.53551 13.7322 9.26751C14.4642 9.99951 15.6432 9.99951 18.0002 9.99951H22.0002",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.06fd590d599e9cb863422c8b4b63bc73.svg";
export { ForwardRef as ReactComponent };